import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGaurd implements CanActivate {

  constructor(private authService: AuthService, private router: Router) {
    this.authService.checkForUser();
  }

  canActivate() {
    if (this.authService.isUserLoggedIn()) return true;

    this.router.navigate(['/login']);
    return false;
  }

}
